import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="header">
      <div className="logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
        Royal Suites Service Apartments
      </div>
      {/* Menu Icon */}
      <div className="menu-icon" onClick={toggleMenu}>
        ☰
      </div>
      {/* Navigation Menu */}
      <nav className={`nav ${menuOpen ? 'open' : ''}`}>
        <ul>
          <li><a href="#properties" onClick={() => setMenuOpen(false)}>Properties</a></li>
          <li><a href="#attractions" onClick={() => setMenuOpen(false)}>Nearby Attractions</a></li>
          <li><a href="#about" onClick={() => setMenuOpen(false)}>About</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
